import React, { FC } from 'react';
import { ScreenSectionFragment } from 'src/modules/dashboard/documents/getHomeScreen.generated';
import { mapContentLinkToActionItemProps } from 'src/modules/dashboard/helpers/contentLinkNodeToActionItem';
import { mapContentLinkToContentCardProps } from 'src/modules/dashboard/helpers/contentLinkNodeToContentCard';
import {
    ActionItemList,
    ActionPropsWithId,
    ContentCardItemWithId,
    ContentCardsRow,
    Grid,
    GridItem,
} from 'src/shared/ds';

interface ContentCardProps {
    links: ScreenSectionFragment['contentCollectionLinks'];
}
export const HorizontalContentCard: FC<ContentCardProps> = ({ links }) => {
    if (!links) {
        return null;
    }

    const mappedLinks = links
        .map(mapContentLinkToContentCardProps)
        .filter((link): link is ContentCardItemWithId => link !== null);

    return <ContentCardsRow items={mappedLinks} />;
};

export const VerticalContentCard: FC<ContentCardProps> = ({ links }) => {
    if (!links) {
        return null;
    }

    const mappedLinks = links
        .map(mapContentLinkToActionItemProps)
        .filter((link): link is ActionPropsWithId => link !== null)
        .reduce<ActionPropsWithId[][]>((mapped, circle, i) => {
            const ii = Math.max(i - 1, 0);
            const index = Math.round(ii / 3);
            const elem = mapped[index];
            if (!elem) {
                mapped[index] = [circle];
            } else {
                mapped[index] = [...elem, circle];
            }
            return mapped;
        }, []);

    return (
        <Grid lgMode="3columns">
            {mappedLinks.map((circles, i) => {
                const hideWidth = i === 1 ? 'sm' : 'md';
                return (
                    <GridItem
                        lg={1}
                        md={2}
                        column
                        hide={i > 0 ? hideWidth : undefined}
                        key={`actionItemList_column_${i}`}
                    >
                        <ActionItemList actions={circles} />
                    </GridItem>
                );
            })}
        </Grid>
    );
};
